var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1638_1180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58342 1.19549C7.39156 1.17644 7.19696 1.16669 7.00008 1.16669C3.77842 1.16669 1.16675 3.77836 1.16675 7.00002C1.16675 10.2217 3.77842 12.8334 7.00008 12.8334C10.2217 12.8334 12.8334 10.2217 12.8334 7.00002C12.8334 6.6005 12.7932 6.2103 12.7167 5.83335",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 6.41667H5.07915C4.81504 6.41667 4.56175 6.31172 4.375 6.125M8.16667 6.41667H8.92086C9.18493 6.41667 9.43827 6.31172 9.625 6.125",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 10.5C7.64425 10.5 8.16659 9.97769 8.16659 9.33335C8.16659 8.68902 7.64425 8.16669 6.99992 8.16669C6.35559 8.16669 5.83325 8.68902 5.83325 9.33335C5.83325 9.97769 6.35559 10.5 6.99992 10.5Z",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91675 1.16669H11.6361C11.9978 1.16669 12.1786 1.16669 12.2268 1.28341C12.275 1.40013 12.1519 1.54015 11.9058 1.8202L10.4911 3.42985C10.245 3.70989 10.1219 3.84991 10.1701 3.96663C10.2183 4.08335 10.3991 4.08335 10.7608 4.08335H12.2501",
    stroke: "#8D8D8D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1638_1180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepIcon);
export default __webpack_public_path__ + "static/media/sleep_icon.af3f828333de8f32d0f675759feaf62f.svg";
export { ForwardRef as ReactComponent };